export enum SubscriptionsStatus {
    ACTIVE= "active",
    CANCELED= 'canceld',
    INCOMPLETE='incomplete',
    INCOMPLETE_EXPIRED="incomplete_expired",
    PAST_DUE="past_due",
    TRIALING="trialing",
    UNPAID="unpaid",
}